module.exports = __webpack_public_path__ + "static/media/A_iko_2_czcionka_hover.15296a79.svg";